import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiValidationErrorComponent } from './api-validation-error/api-validation-error.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ApiValidationErrorComponent],
  exports: [ApiValidationErrorComponent]
})
export class ApiValidationModule { }



// WEBPACK FOOTER //
// /dist/src/app/shared/api-validation/api-validation.module.ts